import { render, staticRenderFns } from "./PrintPosFaMedModular.vue?vue&type=template&id=2d448095&scoped=true"
import script from "./PrintPosFaMedModular.vue?vue&type=script&lang=js"
export * from "./PrintPosFaMedModular.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaMedModular.vue?vue&type=style&index=0&id=2d448095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d448095",
  null
  
)

export default component.exports